import { ReactNode } from 'react';

import styles from './FormGrid.module.scss';

// TODO: extend to make the grid configurable
export const FormGrid = ({ children }: { children: ReactNode }) => {
  return (
    <div className={styles.FormGridContainer}>
      <div className={styles.FormGrid}>{children}</div>
    </div>
  );
};
